import { createHelpers, updateField } from 'vuex-map-fields';
import { get_empresa_datos_vacio } from 'views/components/crm/components/empresa/web_empresa_datos_helper.js';
import { get_web_empresa_congifuracion_vacio } from 'views/components/crm/components/empresa/web_empresa_congifuracion.js';
import Vuex from 'vuex';
import { isEmpty } from 'validate.js';

Vue.use(Vuex);

const { getFieldsEmpresa, updateFieldsTemp } = createHelpers({
  getterType: 'getFieldsEmpresa',
  mutationType: 'updateFieldsTemp',
});

export default {
  namespaced: true,
  state: {
    web_empresa_datos: get_empresa_datos_vacio(),
    web_empresa_congifuracion: get_web_empresa_congifuracion_vacio(),
  },
  mutations: {
    updateFieldsEmpresa(state, payload) {
      // Corregir payload de web_empresa_congifuracion
      if (payload.path === 'web_empresa_congifuracion') {
        if (isEmpty(payload.value.data)) {
          payload.value.data = get_web_empresa_congifuracion_vacio().data;
        }
        payload.value = {
          ...state.web_empresa_congifuracion,
          ...payload.value,
        };
      }

      updateField(state, payload);
    },
  },
  getters: {
    getFieldsEmpresa,
    mostrarOpcionesNoAutorizadas: (state) => {
      const modulosAutorizados = state.web_empresa_congifuracion?.data?.modulosAutorizados || [];
      return modulosAutorizados.includes('misClientes');
    },
  },
};
